import { render, staticRenderFns } from "./MemberAgeGroup.vue?vue&type=template&id=6942502b&scoped=true&"
import script from "./MemberAgeGroup.vue?vue&type=script&lang=js&"
export * from "./MemberAgeGroup.vue?vue&type=script&lang=js&"
import style0 from "./MemberAgeGroup.vue?vue&type=style&index=0&id=6942502b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6942502b",
  null
  
)

export default component.exports